import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListComponent } from './list/list.component';
import { LeavesReportComponent } from './leaves-report/leaves-report.component';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';

const routes: Routes = [
  { path:'list',component:ListComponent},
  { path:'reports',component:LeavesReportComponent,canActivate: [PermissionGuard],
  data: { roles: ['admin','Managment','HR'] } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LeavesRoutingModule { }
